import React from 'react';
import { Grid, Typography, makeStyles, IconButton, Paper, InputBase, FormHelperText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import chrono from "./icon/chrono.png";
import bellIcon from "./icon/bell.png";


const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundColor: 'rgba(171, 171, 171, 0.1)',
    //height: '55px',
    margin: '.3rem 0 1rem 0',
  },
  total: {
    display: 'flex',
    marginTop: 30,
    justifyContent: 'center',
    alignItems: 'center',
    '& h6': {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
      fontWeight: 700,
    },
  },
  blockInputError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subTitle: {
    margin: "0px 20px",
    fontFamily: "FuturaStdBold",
    fontSize: "30px",
    fontWeight: 700,
    color: "#262857",
    lineHeight: "36px",
    '& span': {
      color: "#e84249"
    }
  },
  subTitle2: {
    fontFamily: "FuturaStdBook",
    fontSize: "30px",
    fontWeight: 300,
    margin: "0px 20px",
    color: "#262957",
    lineHeight: "30px"
  },
  iconButton: {
    backgroundColor: "#e84249",
    borderRadius: 0,
    height: "60px",
    borderTopRightRadius: "10px",
    borderBottomRightRadius: "10px",
    '&:hover': {
      backgroundColor: "#e84249",
    }
  },
  emailButton: {
    width:"90%",
    height: "60px",
    backgroundColor: "transparent",
    boxShadow: "none",

    borderRadius: "10px",
    display: 'flex',
    alignItems: 'center',
    justifyContent: "space-between",
  },
  inputButton: {
    height:"60px",
    width: "100%",
    borderTopLeftRadius: "10px",
    borderBottomLeftRadius: "10px",
    border: "1px solid #262957",
    borderRight: "none",
    padding: "10px",
    '&.Mui-error': {
      borderColor: "#AB2221"
    },
    '& input': {
      padding: "7px 0 0px",
      '&::placeholder': {
        color: "#262957",
        fontFamily: "FuturaStdBook",
        fontSize: "22px",
        fontWeight: 300,
      }
    }
  },
  inputError: {
    color: "rgba(171,34,33,1)",
    fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    fontSize: "15px",
    fontWeight: 700,
    fontStyle: "normal",
  }
}));

const TicketRequestForm = ({handleAskTicket, emailValid}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [email, setEmail] = React.useState("");

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={classes.total}>
        <img src={chrono} width="130px"/>
      </Grid>
      <Grid item xs={12} className={classes.total}>
        <Typography align="center" className={classes.subTitle}>
            Ticket(s) disponible(s) en <span>fin du service</span>.
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.total}>
        <Typography align="center" className={classes.subTitle2}>
            Recevez une notification par mail !
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.total}>
        <Paper component="form" className={classes.emailButton}>
          <InputBase
          className={classes.inputButton}
          id="outlined-search"
          placeholder="Votre email@coucou.com"
          type="email"
          error={!emailValid}
          autoFocus
          onChange={(e) => {
            //e.preventDefault();
            setEmail(e.target.value)
          }}
          value={email}
          />
          <IconButton onClick={e => handleAskTicket(e, email)} className={classes.iconButton} aria-label="subscribe">
            <img src={bellIcon}/>
          </IconButton>
        </Paper>

      </Grid>
      {
        !emailValid ? (
          <Grid item xs={12} className={classes.blockInputError}>
            <FormHelperText className={classes.inputError}>Adresse mail invalide</FormHelperText>
          </Grid>
        ) : null
      }

    </Grid>
  )
}

export default TicketRequestForm;